import Instance from '../../../utils/Axios';

const GetPermissoes = () => async (dispatch) => {
  const stateToken = localStorage.token;
  if (stateToken) {
    await Instance()
      .get(`/permissoes/ `)
      .then(({ data }) => {
        if (stateToken) {
          dispatch({ type: 'GET_PERMISSOES', payload: data.yData });
        }
      })
      .catch(({ err }) => console.log(err));
  }
};

export default GetPermissoes;
